<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading> -->
@if (chatsReady$ | async) {
  <app-screen-shell contentWidth="standard" contentInset="page" [contentClass]="'chat-list-screen'" [showHeader]="false">
    <header class="chat-list-header">
      <div class="chat-list-filters" role="tablist" [attr.aria-label]="'chat.filters.label' | translate">
        <button type="button" class="chat-list-filter" [class.is-active]="activeFilter === 'all'" (click)="setFilter('all')">
          {{ 'common.all' | translate }}
        </button>
        <button type="button" class="chat-list-filter" [class.is-active]="activeFilter === 'unread'" (click)="setFilter('unread')">
          {{ 'chat.filters.unread' | translate }}
        </button>
        <button type="button" class="chat-list-filter" [class.is-active]="activeFilter === 'favorites'" (click)="setFilter('favorites')">
          {{ 'chat.filters.favorites' | translate }}
        </button>
        <button type="button" class="chat-list-filter" [class.is-active]="activeFilter === 'groups'" (click)="setFilter('groups')">
          {{ 'chat.filters.groups' | translate }}
        </button>
      </div>
      <button type="button" (click)="createNewChat()" class="chat-list-new-button">
        <i [class]="'common.plus' | nogoshIcon" aria-hidden="true"></i>
        <span class="sr-only">{{ 'chat.new' | translate }}</span>
      </button>
    </header>
    <div class="chat-list">
      @if (filteredChats().length === 0) {
        <div class="chat-list-empty">{{ 'chat.filters.empty' | translate }}</div>
      }
      @for (chat of filteredChats(); track chat) {
        <button type="button" class="chat-list-row" [class.has-unread]="chat.hasNewMessages" (click)="enterChat(chat)">
          @if (isGroupChat(chat)) {
            <div class="chat-list-avatar chat-list-group-avatar chat-list-avatar-match" aria-hidden="true">
              <img class="chat-list-group-avatar-bg" src="../../assets/images/chat-group-goal-pitch.png" [alt]="chat.displayName">
              <span class="chat-list-group-avatar-manager">
                @if (getGroupCenterPlayer(chat)?.avatar) {
                  <img [src]="getGroupCenterPlayer(chat).avatar" onerror="this.src='../../assets/images/user1.jpg'" [alt]="getPlayerInitials(getGroupCenterPlayer(chat))">
                } @else {
                  {{ getPlayerInitials(getGroupCenterPlayer(chat)) }}
                }
              </span>
            </div>
          } @else {
            <div class="chat-list-avatar chat-list-avatar-direct" [class.has-image]="getChatAvatarUrl(chat)">
              @if (getChatAvatarUrl(chat)) {
                <img [src]="getChatAvatarUrl(chat)" onerror="this.src='../../assets/images/user1.jpg'" [alt]="'accessibility.userProfileImage' | translate">
              } @else {
                {{getChatInitials(chat)}}
              }
            </div>
          }
          <div class="chat-list-content">
            <div class="chat-list-main-line">
              <strong class="chat-list-name">{{chat.displayName}}</strong>
            </div>
            @if (chat.messages && chat.messages.length > 0) {
              <div class="chat-list-preview">{{chat.messages[0].text}}</div>
            }
            @if (!chat.messages || chat.messages.length === 0) {
              <div class="chat-list-preview chat-list-preview-empty">{{ 'chat.noMessages' | translate }}</div>
            }
          </div>
          <div class="chat-list-meta">
            @if (getChatActivityLabel(chat)) {
              <span class="chat-list-time">{{getChatActivityLabel(chat)}}</span>
            }
            @if (chat.hasNewMessages) {
              <span class="chat-list-unread">{{chat.unreadCount}}</span>
            }
          </div>
        </button>
      }
      @if (loadingMoreChats) {
        <app-loading-state titleKey="common.loadingData" [compact]="true"></app-loading-state>
      }
    </div>
  </app-screen-shell>
}
